<template>
  <div class="toast-notification" v-show="this.message">
    <span class="notification-message">{{ this.message }}</span>
    <span class="close" @click="closeNotification">X</span>
  </div>
</template>

<script>
export default {
  name: 'ToastNotification',

  props: {
    message: String,
    closed: Function
  },

  methods: {
    closeNotification () {
      if (this.closed) {
        this.closed()
      }
    }
  }
}
</script>

<style scoped>
@import "./../styles/toastNotificationComponent.css";
</style>
